module.exports = __webpack_public_path__ + "akne_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/akne_3_before_tn.jpg
// module id = 1388
// module chunks = 0